import React from 'react'
import PropTypes from 'prop-types'

function markForFlag (flag) {
  if (flag) {
    return (<span className='float-end text-success'>o</span>)
  } else {
    return (<span className='float-end text-danger'>x</span>)
  }
}

class ProgramFlagTable extends React.Component {
  render () {
    let flags = this.props.flags

    return (
      <React.Fragment>
        <div className='row small'>
          <div className='col-md-6'>
            <strong>Vor-/Nachbereitung</strong>
            <ul className='list-unstyled text-muted ms-0'>
              <li className='mb-0'>
                { markForFlag(flags.prep_meeting) }
                Vorbereitungstreffen
              </li>
              <li className='mb-0'>
                { markForFlag(flags.parents_meeting) }
                Elterntreffen
              </li>
              <li className='mb-0'>
                { markForFlag(flags.after_meeting) }
                Nachbereitungstreffen
              </li>
            </ul>
          </div>
          <div className='col-md-6'>
            <strong>Services</strong>
            <ul className='list-unstyled text-muted ms-0'>
              <li className='mb-0'>
                { markForFlag(flags.placement_guaranty) }
                Platzierungsgarantie
              </li>
              <li className='mb-0'>
                { markForFlag(flags.airport_intro) }
                Flughafeneinweisung
              </li>
              <li className='mb-0'>
                { markForFlag(flags.accompanied_flight) }
                Gruppenflugbegleitung
              </li>
              <li className='mb-0'>
                { markForFlag(flags.travel_offer) }
                Reiseangebote im Gastland
              </li>
            </ul>
          </div>
        </div>
        <div className='row small'>
          <div className='col-md-6'>
            <strong>Ermäßigungen</strong>
            <ul className='list-unstyled text-muted ms-0'>
              <li className='mb-0'>
                { markForFlag(flags.siblings_discount) }
                Geschwisterrabatt
              </li>
              <li className='mb-0'>
                { markForFlag(flags.own_guest_family_discount) }
                Rabatt eigene Gastfamilie
              </li>
              <li className='mb-0'>
                { markForFlag(flags.scholarships) }
                Stipendien
              </li>
            </ul>
          </div>
        </div>
      </React.Fragment>
    )
  }
}

ProgramFlagTable.propTypes = {
  flags: PropTypes.object.isRequired
}

export default ProgramFlagTable
